import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { tap } from 'rxjs/operators';
import { Offer, OfferActivity, RequestStatus, NGXLogger } from '@app/shared';

import { OfferService } from '@app/core';
import {
  OfferActionTypes,
  GetOffers,
  GetOffersSuccess,
  GetOffersFailure,
  SetOffer,
  SetOfferSuccess,
  SetOfferFailure,
  GetOffer,
  GetOfferSuccess,
  GetOfferFailure,
  GetOfferTypes,
  GetOfferTypesSuccess,
  GetOfferTypesFailure,
  GetInactiveOfferType,
  GetInactiveOfferTypeSuccess,
  GetInactiveOfferTypeFailure,
  UpdateOffer,
  UpdateOfferSuccess,
  UpdateOfferFailure,
  BatchUpdateOffer,
  BatchUpdateOfferSuccess,
  BatchUpdateOfferFailure,
  IngestOffers,
  IngestOffersSuccess,
  IngestOffersFailure,
  UpdateFaveOffers,
  UpdateFaveOffersSuccess,
  UpdateFaveOffersFailure,
  GetFaveOffers,
  GetFaveOffersSuccess,
  GetFaveOffersFailure,
  CopyOffer,
  CopyOfferSuccess,
  CopyOfferFailure,
  MoveOffer,
  MoveOfferSuccess,
  MoveOfferFailure,
  AssignOffer,
  AssignOfferSuccess,
  AssignOfferFailure,
  AllocateOffer,
  AllocateOfferSuccess,
  AllocateOfferFailure,
  AllocateFaveOffer,
  AllocateFaveOfferSuccess,
  AllocateFaveOfferFailure,
  SwapOffers,
  SwapOffersSuccess,
  SwapOffersFailure,
  MoveAllocation,
  MoveAllocationSuccess,
  MoveAllocationFailure,
  RemoveAllocation,
  RemoveAllocationSuccess,
  RemoveAllocationFailure,
  SetOfferLock,
  SetOfferLockSuccess,
  SetOfferLockFailure,
  UnallocateOffer,
  UnallocateOfferSuccess,
  UnallocateOfferFailure,
  AddMedia,
  AddMediaSuccess,
  AddMediaFailure,
  GetOfferHistory,
  GetOfferHistorySuccess,
  GetOfferHistoryFailure,
  GetHSSCodes,
  GetHSSCodesSuccess,
  GetHSSCodesFailure,
  GetAltFields,
  GetAltFieldsSuccess,
  GetAltFieldsFailure,
  GetFields,
  GetFieldsSuccess,
  GetFieldsFailure,
  GetPreferences,	
  GetPreferencesSuccess,	
  GetPreferencesFailure,

} from '../actions/offer.actions';


@Injectable()
export class OfferEffects {

  constructor(
    private actions: Actions,
    private offerService: OfferService,
    private router: Router,
    private logger:NGXLogger
  ) { }

    @Effect()
    GetOffers: Observable<any> = this.actions
        .ofType(OfferActionTypes.GET_OFFERS)
        .debounceTime(10)
        .map((action: GetOffers) => action.payload)
        .switchMap(payload => {
          return this.offerService.getOffers(payload.searchCriteria.keyword)
            .map((result) => {
              let arr = [];
              // init offer members
              result.data.map(offer => {let tmpOffer = Object.assign( new Offer(), offer ); arr.push(tmpOffer)});

              return new GetOffersSuccess({offers:arr})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetOffersFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetOffersSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_OFFERS_SUCCESS),
      tap((result) => {
      //  this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetOffersFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_OFFERS_FAILURE)
    );

    @Effect()
    GetOfferTypes: Observable<any> = this.actions
        .ofType(OfferActionTypes.GET_OFFER_TYPES)
        .debounceTime(10)
        .map((action: GetOfferTypes) => action.payload)
        .switchMap(payload => {
          return this.offerService.getOfferTypes()
            .map((result) => {
              let arr = [];
              // init offer members
              //result.data.map(offer => {let tmpOffer = Object.assign( new Offer(), offer ); arr.push(tmpOffer)});

              return new GetOfferTypesSuccess({offerTypes:result.data})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetOfferTypesFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetOfferTypesSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_OFFER_TYPES_SUCCESS),
      tap((result) => {
        //this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetOfferTypesFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_OFFER_TYPES_FAILURE)
    );

    @Effect()
    GetInactiveOfferTypes: Observable<any> = this.actions
        .ofType(OfferActionTypes.GET_INACTIVE_OFFER_TYPE)
        .debounceTime(10)
        .map((action: GetInactiveOfferType) => action.payload)
        .switchMap(payload => {
          return this.offerService.getInactiveOfferType(payload.offer)
            .map((result) => {
              let arr = [];
              // init offer members
              //result.data.map(offer => {let tmpOffer = Object.assign( new Offer(), offer ); arr.push(tmpOffer)});

              return new GetInactiveOfferTypeSuccess({inactiveOfferTypes:result.data})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetInactiveOfferTypeFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetInactiveOfferTypeSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_INACTIVE_OFFER_TYPE_SUCCESS),
      tap((result) => {
        //this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetInactiveOfferTypeFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_INACTIVE_OFFER_TYPE_FAILURE)
    );

    // SETTING CURRENT Offer
    /*@Effect()
    SetOffer: Observable<any> = this.actions
        .ofType(OfferActionTypes.SET_OFFER)
        .map((action: GetOffers) => action.payload)
        .switchMap(payload => {
          return this.offerService.getOffer(payload.offer)
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new SetOfferSuccess({selectedOffer:payload.offer})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new SetOfferFailure({ error: error }));
            });
        });*/


    @Effect({ dispatch: false })
    SetOfferSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.SET_OFFER_SUCCESS),
      tap((result) => {

        this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    SetOfferFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.SET_OFFER_FAILURE)
    );

    // GETTING OFFER DETAILS
    @Effect()
    GetOffer: Observable<any> = this.actions
        .ofType(OfferActionTypes.GET_OFFER)
        .map((action: GetOffer) => action.payload)
        .switchMap(payload => {
          return this.offerService.getOffer(payload.offer,payload.includeAssets)
            .map((result) => {
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new GetOfferSuccess({offer:result.data[0]})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetOfferFailure({ error: error }));
            });
        });


    @Effect({ dispatch: false })
    GetOfferSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_OFFER_SUCCESS),
      tap((result) => {

        this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    GetOfferFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_OFFER_FAILURE)
    );


    @Effect()
    UpdateOffer: Observable<any> = this.actions
        .ofType(OfferActionTypes.UPDATE_OFFER)
        .map((action: UpdateOffer) => action.payload)
        .switchMap(payload => {

          return this.offerService.updateOffer(payload.offer,payload.job,payload.allocation,payload.documentSegment)
            .map((result) => {
              //this.logger.debug(result);
              // check for validations
              if(result.data[0].pmValidations && result.data[0].pmValidations.length && result.data[0].pmValidations[0].type === "ERROR"){

                this.logger.info('throwing error');
                let error = result.data[0].pmValidations[0];
                let rs : RequestStatus = new RequestStatus();
                //rs.code = error.status;
                rs.msg = error.type;
                rs.msg = error.message;
                return new UpdateOfferFailure({ errorStatus: rs });

              }else{

                // add the offer to the list of offers
                let offer : Offer = Object.assign(new Offer(),result.data[0]);
                let rs : RequestStatus = new RequestStatus();
                let showVendorUpload = false;
                var ignoreKeys = ['publicOfferAssets','uuid','id'];

                // update the offerType
                if(payload.offer.offerTypeDescr)
                  offer.offerTypeDescr = payload.offer.offerTypeDescr;

                if(payload.offer.offerType)
                  offer.offerType = payload.offerType;

                // if we've created a new offer
                if(!payload.offer.uuid){
                    // only show vendor upload if it's a new offer and type is vendor
                    showVendorUpload = payload.offer.offerTypeDescr === 'Vendor'?true:false;
                    // if it has an allocation we need to add it to the allocation
                    if(payload.allocation){

                      for(let oa of payload.documentSegment.offerAllocation){
                        if(oa.id === payload.allocation.id){
                          oa.publicOffers.push(offer);
                        }
                      }
                      //payload.allocation.publicOffers.push(offer);
                      // increase the allocation count
                      ++payload.documentSegment.offerAssignedCount;

                    }

                    // add it to the document segment if it exists
                    if(payload.documentSegment){
                      payload.documentSegment.publicOffers.push(offer);
                      ++payload.documentSegment.offerAllocationCount;
                    }

                  }else{

                    // loop over the job document segments and upate the matching offer
                    if(payload.job){
                      for (let jobs of payload.job){
                        for(let ds of jobs.documentSegments){
                          for(let o of ds.publicOffers){
                            if(o.uuid === offer.uuid){

                              Object.keys(offer).forEach(function (key) {
                                if(ignoreKeys.indexOf(key) === -1){
                                    o[key] =  offer[key]?offer[key]:null;
                                }
                              });

                              break;
                            }
                          }
                          for(let oa of ds.offerAllocation){
                            for(let o of oa.publicOffers){
                              if(o.uuid === offer.uuid){
                                Object.keys(offer).forEach(function (key) {
                                  if(ignoreKeys.indexOf(key) === -1){
                                      o[key] =  offer[key]?offer[key]:null;
                                  }
                                });
                                break;
                              }
                            }
                          }
                        }
                      }
                    }

                    // now for the document segment
                    // loop over the job document segments and upate the matching offer
                    if(payload.documentSegment){

                      for(let o of payload.documentSegment.publicOffers){
                        if(o.uuid === offer.uuid){
                          Object.keys(offer).forEach(function (key) {
                            if(ignoreKeys.indexOf(key) === -1){
                                o[key] =  offer[key]?offer[key]:null;
                            }
                          });

                          break;
                        }
                      }

                      for(let oa of payload.documentSegment.offerAllocation){
                        for(let o of oa.publicOffers){
                          if(o.uuid === offer.uuid){
                            Object.keys(offer).forEach(function (key) {
                              if(ignoreKeys.indexOf(key) === -1){
                                  o[key] =  offer[key]?offer[key]:null;
                              }
                            });
                            break;
                          }
                        }
                      }
                    }

                }
                payload.offer = offer;

                rs.code = result.code;
                rs.msg = `Offer has been saved`;

                return new UpdateOfferSuccess({successStatus:rs, offer:offer, allocation:payload.allocation, showVendorUpload:showVendorUpload})

              }// end check validation


          })
          .catch((error) => {
            this.logger.debug(error);
            let rs : RequestStatus = new RequestStatus();
            rs.code = error.status;
            rs.msg = error.statusText;
            rs.msg = "Sorry unable to save the Offer."
            return Observable.of(new UpdateOfferFailure({ errorStatus: rs }));
          });
        });

    @Effect({ dispatch: false })
    UpdateOfferSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.UPDATE_OFFER_SUCCESS),
      tap((result) => {
      })
    );

    @Effect({ dispatch: false })
    UpdateOfferFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.UPDATE_OFFER_FAILURE)
    );


    @Effect()
    BatchUpdateOffer: Observable<any> = this.actions
        .ofType(OfferActionTypes.BATCH_UPDATE_OFFER)
        .map((action: UpdateOffer) => action.payload)
        .switchMap(payload => {

          return this.offerService.batchUpdateOffer(payload.offers)
            .map((result) => {
              //this.logger.debug(result);
              // add the offer to the list of offers
              let offer : Offer = result.data[0];
              let rs : RequestStatus = new RequestStatus();
              //const ignoreKeys = ['publicOfferAssets'];
              // if we've created a new offer

            payload.offer = offer;

            rs.code = result.code;
            rs.msg = `Offers has been saved`;
              //return new LogInSuccess({token: user.token, email: payload.email});
            return new BatchUpdateOfferSuccess({successStatus:rs, offer:offer})
          })
          .catch((error) => {
            this.logger.debug(error);
            let rs : RequestStatus = new RequestStatus();
            rs.code = error.status;
            rs.msg = error.statusText;
            rs.msg = "Sorry unable to save the Offers."
            return Observable.of(new BatchUpdateOfferFailure({ errorStatus: rs }));
          });
        });

    @Effect({ dispatch: false })
    BatchUpdateOfferSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.BATCH_UPDATE_OFFER_SUCCESS),
      tap((result) => {

        //this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    BatchUpdateOfferFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.BATCH_UPDATE_OFFER_FAILURE)
    );

    // Favourite Offers

    @Effect()
    GetFaveOffers: Observable<any> = this.actions
        .ofType(OfferActionTypes.GET_FAVE_OFFERS)
        .debounceTime(10)
        .map((action: GetFaveOffers) => action.payload)
        .switchMap(payload => {
          return this.offerService.getFaveOffers()
            .map((result) => {
              //this.logger.debug(result)
              let arr = [];
              // init offer members
              let offers = result.data[0].favouriteoffers;
              offers.map(offer => {let tmpOffer = Object.assign( new Offer(), offer ); arr.push(tmpOffer)});

              return new GetFaveOffersSuccess({offers:arr})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetFaveOffersFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetFaveOffersSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_FAVE_OFFERS_SUCCESS),
      tap((result) => {
        //this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetFaveOffersFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_FAVE_OFFERS_FAILURE)
    );


    @Effect()
    UpdateFaveOffers: Observable<any> = this.actions
        .ofType(OfferActionTypes.UPDATE_FAVE_OFFERS)
        .map((action: UpdateFaveOffers) => action.payload)
        .switchMap(payload => {
          return this.offerService.updateFaveOffers(payload.offer.uuid,payload.action)
            .map((result) => {
              //this.logger.debug(result);
              // add the offer to the list of offers
              if(result.data && result.data.length && result.data[0] !== "failure"){
                let offer : Offer = result.data[0];
                let rs : RequestStatus = new RequestStatus();

                rs.code = result.code;
                rs.msg = `Offer has been added to your favourites`;
                return new UpdateFaveOffersSuccess({successStatus:rs})
              }else{
                throw new Error('Unable to add to favourites:failure');
              }

            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to add to favourites."
              return Observable.of(new UpdateFaveOffersFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    UpdateFaveOffersSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.UPDATE_FAVE_OFFERS_SUCCESS),
      tap((result) => {

        //this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    UpdateFaveOffersFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.UPDATE_FAVE_OFFERS_FAILURE)
    );

    /**
     * Handle Copy Offer Effect.
     * Let the app continue.
     * @param action - name of the operation that failed
     */
    @Effect()
    CopyOffer: Observable<any> = this.actions
        .ofType(OfferActionTypes.COPY_OFFER)
        .map((action: CopyOffer) => action.payload)
        .switchMap(payload => {
          return this.offerService.copyOffer(payload.offer.uuid,payload.jobs)
            .map((result) => {
              //this.logger.debug(result);
              // add the offer to the list of offers
              // let offer : Offer = result.data[0];
              let rs : RequestStatus = new RequestStatus();
              
              rs.code = result.code;
              // rs.msg = `Offer has been copied`;

              if (result.data) {
                if (result.data.length > 0 ) {
                  rs.msg = `Sorry unable to copy offer.`;	
                } else {	
                  rs.msg = `Offer has been copied`;  	
                }
              } else {	
                rs.msg = `Offer has been copied`;  	
              }
              
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new CopyOfferSuccess({successStatus:rs})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to copy offer."
              return Observable.of(new CopyOfferFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    CopyOfferSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.COPY_OFFER_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    CopyOfferFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.COPY_OFFER_FAILURE)
    );


    /**
     * Handle Move Offer Effect.
     * Let the app continue.
     * @param action - name of the operation that failed
     */
    @Effect()
    MoveOffer: Observable<any> = this.actions
        .ofType(OfferActionTypes.MOVE_OFFER)
        .map((action: MoveOffer) => action.payload)
        .switchMap(payload => {
          const pagePos = payload.allocation?payload.allocation.pagePosition:null;
          return this.offerService.moveOffer(payload.offer.uuid,payload.documentSegment.uuid,pagePos)
            .map((result) => {
              //this.logger.debug(result);
              // add the offer to the list of offers
              let offer : Offer = result.data[0];
              let rs : RequestStatus = new RequestStatus();

              for(let oa of payload.documentSegment.offerAllocation){
                for(let o of oa.publicOffers){
                  if(o.uuid === offer.uuid && !payload.allocation){
                    oa.publicOffers = [];
                    break;
                  }
                }
              }

              // check for document segments
              if(payload.jobs){
                for(let job of payload.jobs){
                  for(let ds of job.documentSegments){
                    for(let oa of ds.offerAllocation){
                      for(let o of oa.publicOffers){
                        if(o.uuid === offer.uuid && !payload.allocation){
                          oa.publicOffers = [];
                          break;
                        }
                      }
                    }
                  }
                }


              }

              rs.code = result.code;
              rs.msg = `Offer has been moved`;
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new MoveOfferSuccess({successStatus:rs, offer:offer})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to add to Move Offer."
              return Observable.of(new MoveOfferFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    MoveOfferSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.MOVE_OFFER_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    MoveOfferFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.MOVE_OFFER_FAILURE)
    );



    @Effect()
    AssignOffer: Observable<any> = this.actions
        .ofType(OfferActionTypes.ASSIGN_OFFER)
        .map((action: AssignOffer) => action.payload)
        .switchMap(payload => {
          return this.offerService.assignOffer(payload.offer.uuid,payload.documentSegment.uuid)
            .map((result) => {
              //this.logger.debug(result);
              // add the offer to the list of offers
              let offer : Offer = Object.assign(new Offer(),result.data[0]);
              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = `Offer has been assigned`;
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new AssignOfferSuccess({successStatus:rs, offer:offer})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to assign Offer."
              return Observable.of(new AssignOfferFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    AssignOfferSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.ASSIGN_OFFER_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    AssignOfferFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.ASSIGN_OFFER_FAILURE)
    );


    @Effect()
    AllocateOffer: Observable<any> = this.actions
        .ofType(OfferActionTypes.ALLOCATE_OFFER)
        .map((action: AllocateOffer) => action.payload)
        .switchMap(payload => {
          return this.offerService.allocateOffer(payload.offer.uuid,payload.allocation.id)
            .map((result) => {
              //this.logger.debug(result);
              // add the offer to the list of offers
              let offer : Offer = result.data[0];
              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = `Offer has been allocated`;
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new AllocateOfferSuccess({successStatus:rs, offer:offer})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to allocate Offer."
              return Observable.of(new AllocateOfferFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    AllocateOfferSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.ALLOCATE_OFFER_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    AllocateOfferFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.ALLOCATE_OFFER_FAILURE)
    );

    @Effect()
    AllocateFaveOffer: Observable<any> = this.actions
        .ofType(OfferActionTypes.ALLOCATE_FAVE_OFFER)
        .map((action: AllocateFaveOffer) => action.payload)
        .switchMap(payload => {
          return this.offerService.allocateFaveOffer(payload.offer.uuid,payload.allocation.id)
            .map((result) => {
              //this.logger.debug(result);
              // add the offer to the list of offers
              let offer : Offer = result.data[0];
              let po = payload.allocation.publicOffers[0];

              // BW-281 update the allocation with the new offer.
              // keep the views from the fave offer.
              offer.heroAssetMediaPreviewURL = po.heroAssetMediaPreviewURL;
              offer.heroAssetMediaURL = po.heroAssetMediaURL;
              offer.offerViewPreview = po.offerViewPreview;
              offer.offerViewThumb = po.offerViewThumb;

              payload.allocation.publicOffers = [offer];

              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = `Offer has been allocated`;
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new AllocateFaveOfferSuccess({successStatus:rs, offer:offer})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to allocate Offer."
              return Observable.of(new AllocateFaveOfferFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    AllocateFaveOfferSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.ALLOCATE_FAVE_OFFER_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    AllocateFaveOfferFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.ALLOCATE_FAVE_OFFER_FAILURE)
    );

    /**
     * Handle Swap Offer Effect.
     * Let the app continue.
     * @param action - name of the operation that failed
     */
    @Effect()
    SwapOffers: Observable<any> = this.actions
        .ofType(OfferActionTypes.SWAP_OFFERS)
        .map((action: SwapOffers) => action.payload)
        .switchMap(payload => {
          const pagePos = payload.allocation?payload.allocation.pagePosition:null;
          return this.offerService.swapOffers(payload.offers[0].uuid,payload.offers[1].uuid)
            .map((result) => {

              if(result.data && result.data[0] === 'success'){

                let offer : Offer = result.data[0];
                let rs : RequestStatus = new RequestStatus();

                rs.code = result.code;
                rs.msg = `Offers has been swapped`;

                return new SwapOffersSuccess({successStatus:rs, offer:offer})

              }else{
                let es:RequestStatus = new RequestStatus();
                es.msg = 'Problem Swapping Offers';
                return Observable.of(new SwapOffersFailure({ error: es }));
              }

            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to swap Offers."
              return Observable.of(new SwapOffersFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    SwapOffersSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.SWAP_OFFERS_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    SwapOffersFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.SWAP_OFFERS_FAILURE)
    );


    /**
     * Handle Move Allocation Effect.
     * Let the app continue.
     * @param action - name of the operation that failed
     */



    @Effect()
    MoveAllocation: Observable<any> = this.actions
        .ofType(OfferActionTypes.MOVE_ALLOCATION)
        .map((action: MoveAllocation) => action.payload)
        .switchMap(payload => {
          return this.offerService.moveAllocation(payload.allocation.id,payload.position)
            .map((result) => {
              let allocations = payload.allocations;
              let targetPos = -1;
              let currentPos = -1;
              let targetAlloc;
              for(var i = 0; i<payload.allocations.length; i++){
                if(payload.allocations[i].id === payload.allocation.id){
                  currentPos = payload.allocations[i].pagePosition;
                }
                if(payload.allocations[i].pagePosition === payload.position){
                  targetAlloc = payload.allocations[i];
                }
              }

              targetAlloc.pagePosition = currentPos;
              payload.allocation.pagePosition = payload.position;

              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = `Allocation has been moved`;
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new MoveAllocationSuccess({successStatus:rs})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to move the allocation."
              return Observable.of(new MoveAllocationFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    MoveAllocationSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.MOVE_ALLOCATION_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    MoveAllocationFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.MOVE_ALLOCATION_FAILURE)
    );


    /**
     * Handle Move Allocation Effect.
     * Let the app continue.
     * @param action - name of the operation that failed
     */
    @Effect()
    RemoveAllocation: Observable<any> = this.actions
        .ofType(OfferActionTypes.REMOVE_ALLOCATION)
        .map((action: RemoveAllocation) => action.payload)
        .switchMap(payload => {
          return this.offerService.removeAllocation(payload.allocation.id)
            .map((result) => {
              console.log('here');
              // update the document segment count.
              --payload.documentSegment.offerAllocationCount;
              if(payload.allocation.publicOffers.length){
                --payload.documentSegment.offerAssignedCount;
              }

              //this.logger.debug(result);
              let currentPos = -1;
              for(var i = 0; i<payload.allocations.length; i++){
                if(payload.allocations[i].id === payload.allocation.id){
                  currentPos = i;
                  break;
                }
              }

              payload.allocations.splice(currentPos,1);

              // https://wellcomworldwide.atlassian.net/browse/BW-293
              // update the offer allocation page number
              payload.allocations.forEach((alloc,i) => alloc.pagePosition = (i+1));

              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = `Allocation has been removed`;
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new RemoveAllocationSuccess({successStatus:rs})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to move the allocation."
              return Observable.of(new RemoveAllocationFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    RemoveAllocationSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.REMOVE_ALLOCATION_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    RemoveAllocationFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.REMOVE_ALLOCATION_FAILURE)
    );

    /**
     * Set Offer Lock.
     * Allows the lock/unlock of offer
     * @param action - name of the operation that failed
     */
    @Effect()
    SetOfferLock: Observable<any> = this.actions
        .ofType(OfferActionTypes.SET_OFFER_LOCK)
        .map((action: SetOfferLock) => action.payload)
        .switchMap(payload => {
          return this.offerService.setOfferLock(payload.offer.uuid,payload.offer.lockStatus)
            .map((result) => {
              //this.logger.debug(result);

              if(result.data.length && result.data[0].type && result.data[0].type === "ERROR"){
                let error = result.data[0];
                let rs : RequestStatus = new RequestStatus();
                rs.code = error.type;
                rs.msg = error.message;
                return new SetOfferLockFailure({ errorStatus: rs });

              }else{
                // add the offer to the list of offers
                let offer : Offer = result.data[0];
                let rs : RequestStatus = new RequestStatus();
                let status :string = payload.offer.lockStatus === "T"?'locked':'unlocked';
                rs.code = result.code;
                rs.msg = `Offer has been ${status}`;

                if(payload.documentSegment != undefined) {
                  for(let oa of payload.documentSegment.offerAllocation){
                    for(let o of oa.publicOffers){
                      if(o.uuid === payload.offer.uuid){
                        o.lockStatus = payload.offer.lockStatus;
                        break;
                      }
                    }
                  }
                }

                // check for document segments
                if(payload.jobs){
                  for(let job of payload.jobs){
                    for(let ds of job.documentSegments){
                      for(let oa of ds.offerAllocation){
                        for(let o of oa.publicOffers){
                          if(o.uuid === payload.offer.uuid){
                            o.lockStatus = payload.offer.lockStatus;
                            break;
                          }
                        }
                      }
                    }
                  }
                }

                //return new LogInSuccess({token: user.token, email: payload.email});
                return new SetOfferLockSuccess({successStatus:rs, offer:offer})
              }

            })
            .catch((error) => {
              //this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to update offer."
              return Observable.of(new SetOfferLockFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    SetOfferLockSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.SET_OFFER_LOCK_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    SetOfferLockFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.SET_OFFER_LOCK_FAILURE)
    );

    @Effect()
    UnallocateOffer: Observable<any> = this.actions
        .ofType(OfferActionTypes.UNALLOCATE_OFFER)
        .map((action: UnallocateOffer) => action.payload)
        .switchMap(payload => {
          return this.offerService.unallocateOffer(payload.offer.uuid)
            .map((result) => {
              //this.logger.debug(result);

              let offer : Offer = result.data[0];
              let rs : RequestStatus = new RequestStatus();
              if(payload.documentSegment){
                --payload.documentSegment.offerAssignedCount;
                for(let oa of payload.documentSegment.offerAllocation){
                  for(let o of oa.publicOffers){
                    if(o.uuid === offer.uuid && !payload.allocation){
                      oa.publicOffers = [];
                      oa.viewTemplate = null;
                      break;
                    }
                  }
                }
              }

              // check for document segments
              if(payload.jobs){
                for(let job of payload.jobs){
                  for(let ds of job.documentSegments){
                    for(let oa of ds.offerAllocation){
                      for(let o of oa.publicOffers){
                        if(o.uuid === offer.uuid && !payload.allocation){
                          oa.publicOffers = [];
                          oa.viewTemplate = null;
                          break;
                        }
                      }
                    }
                  }
                }
              }

              rs.code = result.code;
              rs.msg = `Offer has been unallocated`;
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new UnallocateOfferSuccess({successStatus:rs, offer:offer})
            })
            .catch((error) => {
              this.logger.debug(error);
              console.log(error)
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to unallocate Offer."
              return Observable.of(new UnallocateOfferFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    UnallocateOfferSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.UNALLOCATE_OFFER_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    UnallocateOfferFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.UNALLOCATE_OFFER_FAILURE)
    );

    /**
     * Handle Add Media
     * Let the app continue.
     * @param action - name of the operation that failed
     */
    @Effect()
    AddMedia: Observable<any> = this.actions
        .ofType(OfferActionTypes.ADD_MEDIA)
        .map((action: AddMedia) => action.payload)
        .switchMap(payload => {

          if(payload.filename){
            return this.offerService.addMedia(payload.filename,payload.offer.uuid,payload.token)
              .map((result) => {
                let offer : Offer = result.data[0];
                return new AddMediaSuccess({offer:offer})
              })
          }else{
            return Observable.of(new AddMediaSuccess({ offer: payload.offer }));
          }

        });

    @Effect({ dispatch: false })
    AddMediaSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.ADD_MEDIA_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    AddMediaFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.ADD_MEDIA_FAILURE)
    );

    /**
     * Handle Get Offer History
     * Let the app continue.
     * @param action - name of the operation that failed
     */
    @Effect()
    GetOfferHistory: Observable<any> = this.actions
        .ofType(OfferActionTypes.GET_OFFER_HISTORY)
        .debounceTime(10)
        .map((action: GetOfferHistory) => action.payload)
        .switchMap(payload => {
          return this.offerService.getOfferHistory(payload.offer.uuid)
            .map((result) => {
              let arr = [];
              // init offer members
              payload.offer.offerActivities = [];
              result.activities.map(activity => {let tmpActivity = Object.assign( new OfferActivity(), activity ); payload.offer.offerActivities.push(tmpActivity)});

              return new GetOfferHistorySuccess({offer:payload.offer})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetOfferHistoryFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetOfferHistorySuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_OFFER_HISTORY_SUCCESS),
      tap((result) => {
      //  this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetOfferHistoryFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_OFFER_HISTORY_FAILURE)
    );

    /**
     * Handle Get Offer HSS Codes
     * Let the app continue.
     * @param action - name of the operation that failed
     */
    @Effect()
    GetHSSCodes: Observable<any> = this.actions
        .ofType(OfferActionTypes.GET_HSS_CODES)
        .debounceTime(10)
        .map((action: GetHSSCodes) => action.payload)
        .switchMap(payload => {
          return this.offerService.getOfferHSSCodes()
            .map((result) => {
              let arr = [];
              // init offer members

              return new GetHSSCodesSuccess({hssCodes:result})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetHSSCodesFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetHSSCodesSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_HSS_CODES_SUCCESS),
      tap((result) => {
      //  this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetHSSCodesFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_HSS_CODES_FAILURE)
    );

    @Effect()
    GetAltFields: Observable<any> = this.actions
        .ofType(OfferActionTypes.GET_ALT_FIELDS)
        .debounceTime(10)
        .map((action: GetAltFields) => action.payload)
        .switchMap(payload => {
          return this.offerService.getAltFields()
            .map((result) => {
              let arr = [];
              // init offer members
              return new GetAltFieldsSuccess({altFields:result})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetAltFieldsFailure({ error: error }));
            });
        })
    @Effect({ dispatch: false })
    GetAltFieldsSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_ALT_FIELDS_SUCCESS),
      tap((result) => {
      //  this.logger.debug(result, ' in tap')
      })
    );
    @Effect({ dispatch: false })
    GetAltFieldsFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_ALT_FIELDS_FAILURE)
    );

    @Effect()
    GetFields: Observable<any> = this.actions
        .ofType(OfferActionTypes.GET_FIELDS)
        .debounceTime(10)
        .map((action: GetFields) => action.payload)
        .switchMap(payload => {
          return this.offerService.getFields()
            .map((result) => {
              let arr = [];
              // init offer members
              return new GetFieldsSuccess({fields:result})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetFieldsFailure({ error: error }));
            });
        })
    @Effect({ dispatch: false })
    GetFieldsSuccess: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_FIELDS_SUCCESS),
      tap((result) => {
      //  this.logger.debug(result, ' in tap')
      })
    );
    @Effect({ dispatch: false })
    GetFieldsFailure: Observable<any> = this.actions.pipe(
      ofType(OfferActionTypes.GET_FIELDS_FAILURE)
    );


    @Effect()	
    GetPreferences: Observable<any> = this.actions	
        .ofType(OfferActionTypes.GET_PREFERENCES)	
        .debounceTime(10)	
        .map((action: GetPreferences) => action.payload)	
        .switchMap(payload => {
          return this.offerService.getPreferences()	
            .map((result) => {	
              let arr = [];	
              return new GetPreferencesSuccess({preferences:result})	
            })	
            .catch((error) => {	
              this.logger.debug(error);	
              return Observable.of(new GetPreferencesFailure({ error: error }));	
            });	
        })	
    @Effect({ dispatch: false })	
    GetPreferencesSuccess: Observable<any> = this.actions.pipe(	
      ofType(OfferActionTypes.GET_PREFERENCES_SUCCESS),	
      tap((result) => {	
      //  this.logger.debug(result, ' in tap')	
      })	
    );	
    @Effect({ dispatch: false })	
    GetPreferencesFailure: Observable<any> = this.actions.pipe(	
      ofType(OfferActionTypes.GET_PREFERENCES_FAILURE)	
    );
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/effects/offer.effects.ts